import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

import EFProductWinAdd from '@/components/UI/svg/mm100/Icon/EFProductWinAdd';

export default function Comp({ callBack }: any) {
    const { useLang, useState } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    const openAllWin = () => {
        callBack('LFP-Batteries');
    };

    return (
        <div className={`${css.kitM} kitM`}>
            <div className="kit-ms1">{t('presale.product.kitM_ms1')}</div>
            <div className="kit-ms2">{t('presale.product.kitM_ms2')}</div>
            <div className="kit-ms3">{t('presale.product.kitM_ms3')}</div>
            <div className="more-win-fun" onClick={openAllWin}>
                {t('presale.product.kitM_more_win_fun')}
                <span className="more-win-fun-icon">
                    <EFProductWinAdd />
                </span>
            </div>
        </div>
    );
}
